import { FC, useEffect, useState } from 'react';
import { AllieTextProps, TextType } from './Text.types';
import { isMobile, isSmartTV } from '../../common/utils';
import { AllieTextWrapper, AllieTextStyled } from './Text.styles';

export const AllieText: FC<AllieTextProps> = ({
  type = 'body1',
  color = 'neutral',
  hoverColor,
  weight,
  className,
  typeSet,
  ...props
}) => {
  const [currentType, setCurrentType] = useState<TextType>(type);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const sortedTypeSet = [...(typeSet || [])].sort((a, b) => b.resolution - a.resolution);
      const matchedItem = sortedTypeSet.find((item) => screenWidth >= item.resolution);

      if (matchedItem) {
        setCurrentType(matchedItem.type);
      } else {
        setCurrentType(type);
      }
    };

    if (typeSet && typeSet.length > 0) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
    return () => window.removeEventListener('resize', handleResize);
  }, [typeSet, type]);

  let suffix = '';
  if (isMobile) suffix = '-mobile';
  if (isSmartTV) suffix = '-tv';

  return (
    <AllieTextWrapper
      $hoverColor={hoverColor}
      className={`${className || ''} allie-text-${currentType}${suffix} allie-text-${color}`}
      style={{ ...(weight ? { fontWeight: weight } : null) }}
    >
      <AllieTextStyled {...props} />
    </AllieTextWrapper>
  );
};

